export const RECOMMENDED_FOR_YOU = 'Recommended_For_You'
export const RECOMMENDED_CAT_PAGE = 'Recommended_Cat_Page'
export const REPURCHASE_SWIMLANE = 'Repurchase_swimlane'
export const RECOMMENDED_CART_PAGE = 'Recommended_Cart_Page'
export const RECOMMENDED_MARKETPLACE = 'Recommended_Marketplace_Page'
export const SMART_RECOMMENDER_CAT_PAGE = 'Smart_Recommender_For_You'
export const PAST_PURCHASE_CART_PAGE = 'Your Past Purchases'
